// @ts-check
import RoleTooltip from "./tooltip.js";

export default RoleTooltip;

RoleTooltip.define();
